module.exports = __webpack_public_path__ + "static/whitestone-nuneaton-christadelphians-78003fbcaadf6cd34e7a5a6176d6517c.svg";